import { EpimsBaseEntityDto } from './epim-base.dto';
export class SeismicCurrencyDto extends EpimsBaseEntityDto {
  CurrencyName: string;
  SubscriberEmail: string;
  SubscriptionUserId: string;
  Version: number;
}
